import type { ComponentProps, FC, ReactNode } from 'react';
import { Button } from '@george-labs.com/design-system';

import type { Account } from '@shared/products-types';
import { AliasChangeDropdown } from '@retail/products-customisation';
import { t } from '@luna/i18n';
import { useActiveCustomizationFeature, useActiveProduct } from '@shared/products-core';

import { useProductData } from '../../../hooks/useProductData';

type Props = {
    toggle?: ReactNode;
    trigger: ComponentProps<typeof AliasChangeDropdown>['trigger'];
};

export const AliasChange: FC<Props> = ({ toggle, trigger }) => {
    const { activateAliasChangeCustomization } = useActiveCustomizationFeature();
    const { productI18N, alias = '', id } = useActiveProduct<Account>();
    const { updateAlias } = useProductData(id);

    const aliasChangeToggle = toggle || (
        <Button
            icon={Button.ICON.EDIT}
            size={Button.SIZE.SMALL}
            onClick={activateAliasChangeCustomization}
            data-cy="product-settings-edit-alias-button"
            className="g-inverted"
        >
            {t('mainOverview.action.changeName_a11y')}
        </Button>
    );

    return (
        <AliasChangeDropdown
            alias={alias}
            hasAlias={Boolean(alias)}
            aliasChangeContext="dashboard"
            onAliasSave={updateAlias}
            productType={productI18N}
            toggle={aliasChangeToggle}
            placeholder={productI18N}
            trigger={trigger}
        />
    );
};
